<template>
    <vue-box class="bax-create-patient">
        <div v-if="created === false" key="bax-create-patient-key">
            <div class="bax-section-title">
                <vue-heading :size="1" v-if="!isTPN()">Create a New Patient</vue-heading>
                <vue-heading :size="1" v-if="isTPN()">Create a New TPN Patient</vue-heading>
            </div>
            <div>
                <form novalidate @submit.prevent="submitForm">
                    <ul class="bax-diamond-list">
                        <li class="bax-diamond-list-item">
                            <div class="bax-form-group" v-bind:class="{ 'bax-input-error' : !isMerlinApi && $v.formData.patientId.$error }">
                                <label>Patient ID <span v-if="isMerlinApi"> - Optional</span></label>
                                <input v-model="formData.patientId" class="bax-input-control" type="text" placeholder="Patient ID">
                                <p v-if="!isMerlinApi && $v.formData.patientId.$dirty && !$v.formData.patientId.required">Patient ID is required</p>
                            </div>
                        </li>
                        <li class="bax-diamond-list-item">
                            <div class="bax-form-group" v-bind:class="{ 'bax-input-error' : $v.formData.firstName.$error }">
                                <label>First name</label>
                                <input v-model="formData.firstName" maxlength="20" class="bax-input-control" type="text" placeholder="First name">
                                <p v-if="$v.formData.firstName.$dirty && !$v.formData.firstName.required">First name is required</p>
                            </div>
                        </li>
                        <li class="bax-diamond-list-item">
                            <div class="bax-form-group" v-bind:class="{ 'bax-input-error' : $v.formData.lastName.$error }">
                                <label>Last name</label>
                                <input v-model="formData.lastName"  maxlength="20" class="bax-input-control" type="text" placeholder="Last name">
                                <p v-if="$v.formData.lastName.$dirty && !$v.formData.lastName.required">Last name is required</p>
                            </div>
                        </li>
                        <li class="bax-diamond-list-item">
                            <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.formData.dateOfBirth.$error }">
                                <label>Date of birth - <span>Optional</span></label>
                                <date-entry v-model="formData.dateOfBirth" :disableDatePicker="true" :prevDatesOnly="true"></date-entry>
                                <p v-if="$v.formData.dateOfBirth.$dirty && !$v.formData.dateOfBirth.validDate">Enter a valid date of birth</p>
                            </div>
                        </li>
<!--                        <li class="bax-diamond-list-item">-->
<!--                            <div class="bax-form-group">-->
<!--                                <label>Ward - <span>Optional</span></label>-->
<!--                                <select class="bax-input-control" v-model="formData.wardId">-->
<!--                                    <option value="">- Select -</option>-->
<!--                                    <option v-for="(ward, i) in wards" :key="i" :value="ward.wardId">{{ ward.wardName }}</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </li>-->
                        <li class="bax-diamond-list-item">
                            <div class="bax-form-group">
                                <label for="ward">{{hcpLabel}} - <span>Optional</span></label>
                                <input class="bax-input-control" type="text" placeholder="Doctor">
                            </div>
                        </li>
                    </ul>
                    <div class="bax-cta-block d-flex">
                        <vue-button type="button" color="link" @click.native="$emit('close')">Back</vue-button>
                        <vue-button type="submit" color="primary" class="ml-auto">Create patient</vue-button>
                    </div>
                </form>
            </div>
        </div>
        <div v-else>
            <div class="bax-section-title">
                <h2 class="d-flex align-items-center">
                    <span class="bax-icon-check">
                        <i class="icon-tick d-flex align-items-center justify-content-center"></i>
                    </span>Patient successfully created
                </h2>
            </div>
            <div class="bax-patient-detail-list">
                <ul>
                    <li class="d-flex align-items-center" v-if="formData.patientId != ''">
                        <span>Patient ID</span>
                        <h4>{{ this.formData.patientId }}</h4>
                    </li>
                    <li class="d-flex align-items-center">
                        <span>First name</span>
                        <h4>{{ this.formData.firstName?this.formData.firstName:'--' }}</h4>
                    </li>
                    <li class="d-flex align-items-center">
                        <span>Last name</span>
                        <h4>{{ this.formData.lastName?this.formData.lastName:'--' }}</h4>
                    </li>
                    <li class="d-flex align-items-center">
                        <span>Date of birth</span>
                        <h4>{{ this.formData.dateOfBirth ? this.formData.dateOfBirth : '--' }}</h4>
                    </li>
<!--                    <li class="d-flex align-items-center">-->
<!--                        <span>Ward</span>-->
<!--                        <h4>{{ this.formData.wardId }}</h4>-->
<!--                    </li>-->
                </ul>
                <div class="bax-cta-block d-flex">
                    <vue-button
                        type="button"
                        color="link"
                        @click.native="showCreateForm"
                    >Back</vue-button>
                    <button
                            type="button"
                            class="bax-btn bax-btn bax-btn-blue ml-auto"
                            @click="setOrderPatient"
                            v-if="!isTPN()"
                    >Continue to drug selection</button>
                    <button
                            type="button"
                            class="bax-btn bax-btn bax-btn-blue ml-auto"
                            @click="setOrderPatient"
                            v-if="isTPN()"
                    >Continue to formulation selection</button>
                </div>
            </div>
        </div>

        <vue-modal :open="patientExistModal">
            <div class="bax-modal-content bax-modal-icon-content text-center">
                <div class="bax-icon bax-information d-flex align-items-center justify-content-center">
                    <i class="icon-information"></i>
                </div>
                <h2>{{ patientError }}</h2>
                <p>{{ patientExistError }}</p>
                <br />
                <template v-if="patientErrorContact"><div v-html='patientErrorContact'></div></template>
                <div class="bax-modal-action-items">
                    <ul class="d-md-flex justify-content-center">
                        <li>
                            <a
                                href="#" @click.prevent="patientExistModal = false"
                                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                            >Close</a>
                        </li>
                    </ul>
                </div>
            </div>
        </vue-modal>

    </vue-box>
</template>

<script>
import moment from 'moment';
import { scrollPageToTop } from '@/core/helpers';
import DateEntry from '@/components/ui/DateEntry.vue';
import OrderService from '@/core/api/order/order.service';
import PatientService from '@/core/api/patient/patient.service';
import tpnMixin from '@/mixins/tpnMixin';
import { mapGetters } from 'vuex';

export default {
    name: 'CreatePatientForm',
    mixins: [tpnMixin],
    components: {
        DateEntry,
    },
    computed: {
      ...mapGetters(['authenticatedUser']),
    },
    created() {
      if (this.authenticatedUser) {
        if (this.authenticatedUser.hospitalCountry === 'United Kingdom') {
          this.hcpLabel = 'Healthcare Professional';
        }
      }
      if (this.apiDetails.api.toLowerCase().trim() === 'merlin' && this.apiDetails.region.toLowerCase().trim() === 'apac') {
            this.isMerlinApi = true;
      }
    },
    data() {
        return {
            patientExistModal: false,
            patientExistError: '',
            wards: [],
            created: false,
            errors: {
                patientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                wardId: '',
            },
            formData: {
                patientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                wardId: '',
            },
            patientId: '',
            patientError: '',
            patientErrorContact: 'xxxx',
            isMerlinApi: false,
            hcpLabel: 'Doctor',
        };
    },
    validations: {
        formData: {
            patientId: {
                required(val) {
                    if (this.isMerlinApi) {
                        return true;
                    }
                    if (val === '') {
                        return false;
                    }
                    return true;
                },
            },
            firstName: {
              required() {
                return true;
              },
            },
            lastName: {
                required() {
                  return true;
                },
            },
            dateOfBirth: {
                validDate(val) {
                    if (val === '') {
                        return true;
                    }

                    const isValidFormat = moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid();

                    if (!isValidFormat) {
                        return false;
                    }

                    const birthDate = moment(val, ['DD/MM/YYYY', 'D/M/YYYY']);
                    const now = moment();
                    return birthDate.isBefore(now);
                },
            },
        },
    },
    props: ['apiDetails'],
    mounted() {
        this.patientErrorContact = this.authenticatedUser.baxterContent['PATIENT ERROR'];
    },
    methods: {
        submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const formData = {
                id: this.formData.patientId,
                firstName: this.formData.firstName,
                lastName: this.formData.lastName,
                dateOfBirth: this.formData.dateOfBirth,
                wardId: this.formData.wardId,
            };

            PatientService.createPatient(formData).then((res) => {
                this.patientId = res.data.patientId;
                this.created = true;
                scrollPageToTop();
                this.patientExistError = '';
            })
            .catch((err) => {
                if (err.response.status === 409) {
                    this.patientError = 'Sorry, the medical record number (MRN) already exists';
                    this.patientExistError = err.response.data.message;
                    this.patientExistModal = true;
                } else
                if (err.response.status === 422) {
                    this.patientError = 'Sorry, a medical record number (MRN) is required';
                    this.patientExistError = err.response.data.message;
                    this.patientExistModal = true;
                }
            });
        },
        showCreateForm() {
            this.$v.$reset();
            this.created = false;
            this.formData = {
                patientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                wardId: '',
            };
            scrollPageToTop();
        },
        setOrderPatient() {
            OrderService.addOrderPatient({
                orderRef: this.$route.params.orderId,
                patientId: this.patientId,
            })
                .then(() => {
                    this.$router.push({
                        name: 'drugDetail',
                        params: {
                            orderId: this.$route.params.orderId,
                            patient: this.patientId,
                        },
                    });
                });
        },
    },
};
</script>


<style scoped lang="scss">
.bax-error {
  .date-error {
    font-size: 15px;
    color: red;
    margin-top: 5px;
  }
}
</style>
